import App from './App';
import CssBaseline from '@material-ui/core/CssBaseline';
import ErrorMsg from 'components/ErrorBoundaryUI';
import LogRocket from 'logrocket';
import React from 'react';
import ReactDOM from 'react-dom';
import client from './graphql/apollo-client';
import theme from './theme';
import { ApolloProvider } from '@apollo/client';
import { AuthProvider, FirebaseAppProvider } from 'reactfire';
import { ErrorBoundary } from 'react-error-boundary';
import { ThemeProvider } from '@mui/material';
import { auth, firebaseConfig } from './utils/firebase';
import { datadogRum } from '@datadog/browser-rum';
import './index.css';
import './utils/console';

if (process.env.KDS_NODE_ENV == 'dev' || process.env.KDS_NODE_ENV == 'prod') {
  datadogRum.init({
    applicationId: process.env.DATADOG_APPLICATION_ID,
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    env: process.env.DATADOG_ENV,
    site: process.env.DATADOG_SITE,
    service: process.env.DATADOG_SERVICE,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.GIT_VERSION,
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.startSessionReplayRecording();
  const keyValPairs = JSON.parse(process.env.DATADOG_SRE_TAGS_JSON);
  for (const key in keyValPairs) {
    datadogRum.addRumGlobalContext(key, keyValPairs[key]);
  }
}

function onErrorHandler(error: Error, info: { componentStack: string }) {
  try {
    LogRocket.captureException(error, {
      extra: {
        errorMessage: error.message,
        componentStack: info.componentStack,
      },
    });
  } catch (error) {
    console.log('Error while logging to LogRocket from error boundary', error);
  }
}

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary fallback={<ErrorMsg />} onError={onErrorHandler}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <FirebaseAppProvider firebaseConfig={firebaseConfig}>
          <AuthProvider sdk={auth}>
            <ApolloProvider client={client}>
              <App />
            </ApolloProvider>
          </AuthProvider>
        </FirebaseAppProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.querySelector('#root')
);
